import * as React from 'react'

import { ExternalLinkIcon } from 'lucide-react'
import { inject, observer } from 'mobx-react'
import { classList } from 'react-classlist-helper'

import Localization from '../../localization/LocalizationManager'
import { getSharedProjectName, SharedInfo } from '../../models/SharedInfo'
import Workflow from '../../models/Workflow'
import ProjectsStore from '../../stores/domain/Projects.store'
import { NOOP } from '../../utils/noop'
import { EMPTY_STRING } from '../../utils/usefulStrings'
import PermitListItem from '../PermitListItem'

import './PermitCard.scss'

interface IProps {
  permit: Workflow
  className?: string
  onClick?: (permit: Workflow) => void

  isShared?: boolean
  sharedInfo?: SharedInfo
  projectsStore?: ProjectsStore
  displayOnlyBacklinks?: boolean
  onBacklinksWorkflowClick?: (workflow: Workflow) => void
}

@inject('projectsStore')
@observer
export default class PermitCard extends React.Component<IProps> {
  public static defaultProps = {
    className: EMPTY_STRING,
    onClick: NOOP,
  }

  public render(): JSX.Element {
    const { className, isShared, permit } = this.props

    return (
      <article
        data-testid={`workflow-card-${permit.id}`}
        className={classList({
          'permit-card col full-height': true,
          [className]: !!className,
          pa12: !isShared,
          ma0: isShared,
        })}
      >
        {this.header ? (
          <div className="col shared-event-card">
            {this.header}
            <div className="px10 pt5">{this.body}</div>
          </div>
        ) : (
          this.body
        )}
      </article>
    )
  }

  private get body(): JSX.Element {
    const { permit, onClick, displayOnlyBacklinks, onBacklinksWorkflowClick } =
      this.props
    return (
      <PermitListItem
        permit={permit}
        onClick={onClick}
        displayOnlyBacklinks={displayOnlyBacklinks}
        onBacklinksWorkflowClick={onBacklinksWorkflowClick}
      />
    )
  }

  protected get header(): JSX.Element {
    const { isShared, sharedInfo, projectsStore } = this.props
    if (!isShared || !sharedInfo) {
      return null
    }

    return (
      <div className="row unset-flex-children-direct pl10 text bold extra-large shared-event-header">
        <ExternalLinkIcon size={16} className="tw:mr-5 tw:text-background" />
        <div className="text bold white large">
          {Localization.translator.sharedFrom}
          <span className="text bold white large underline ml5">
            {getSharedProjectName(
              sharedInfo.projectUrl,
              projectsStore,
              sharedInfo.projectFromId,
            )}
          </span>
        </div>
      </div>
    )
  }
}
